import React from 'react';
import { motion } from 'framer-motion';
import './AIMock.css';
import interviewImg from '../Images/mock.jpg';
import { Link } from 'react-router-dom';

const AiMockInterview = () => {
  return (
    <div className="ai-interview-container">
      <motion.div
        className="ai-interview-text"
        initial={{ x: -80, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <motion.h1
          className="ai-interview-heading"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <span className="ai-heading-black">AI Mock Interviews</span>
          <span className="ai-heading-blue">Practice. Improve. Succeed.</span>
        </motion.h1>

        <motion.p
          className="ai-interview-description"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          Sharpen your interview skills with realistic AI-driven mock interviews. Get instant feedback,
          personalized tips, and boost your confidence – anytime, anywhere.
        </motion.p>

        <div className="ai-feature-list">
          {[
            '🧠 Real-Time AI Evaluation',
            '🎤 Voice & Video Interview Modes',
            '📊 Personalized Performance Report',
            '📚 Tailored Questions by Role',
          ].map((item, index) => (
            <motion.div
              key={index}
              className="ai-feature-card"
              whileHover={{ scale: 1.05 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 + index * 0.2 }}
            >
              {item}
            </motion.div>
          ))}
        </div>

        <div className="ai-buttons">
          <Link to= "/SignupForm"> 
          <motion.button className="ai-btn primary" whileHover={{ scale: 1.05 }}>
            Try Free Interview
          </motion.button></Link>
       
          <motion.button className="ai-btn secondary" whileHover={{ scale: 1.05 }}>
            Book Live Demo
          </motion.button>
       
        </div>

        <motion.div
          className="ai-note"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          🔒 100% Confidential | 💼 Trusted by 500+ recruiters | 🕒 Interview in under 10 mins
        </motion.div>
      </motion.div>

      <motion.div
        className="ai-interview-image-box"
        initial={{ x: 80, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.2 }}
      >
        <motion.img
          src={interviewImg}
          alt="AI Mock Interview"
          className="ai-interview-image"
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 4, repeat: Infinity }}
        />
      </motion.div>
    </div>
  );
};

export default AiMockInterview;
